import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Card, CardContent, Divider, Fade, Grid, Typography, } from "@mui/material";
const IAContent = ({ texto, children }) => {
    const palavras = texto.split(" ");
    const [mostrarBox, setMostrarBox] = useState(false);
    const [index, setIndex] = useState(0);
    useEffect(() => {
        setIndex(0); // resetar caso mude o texto
        const timer = setInterval(() => {
            setIndex((prev) => {
                if (prev >= palavras.length - 1) {
                    clearInterval(timer);
                    return prev;
                }
                return prev + 1;
            });
        }, 150);
        return () => clearInterval(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [texto]);
    useEffect(() => {
        const timer = setTimeout(() => {
            setMostrarBox(true);
        }, 2000); // 3000ms = 3 segundos
        return () => clearTimeout(timer);
    }, []);
    return (_jsxs(Grid, Object.assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12, md: 4 }, { children: _jsx(Card, Object.assign({ variant: "outlined" }, { children: _jsx(CardContent, { children: _jsxs(Grid, Object.assign({ container: true, sx: {
                                display: "flex",
                                alignContent: "center",
                                alignItems: "center",
                            } }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12, md: 4 }, { children: _jsx("img", { src: `${process.env.PUBLIC_URL}/images/robo.gif`, alt: "robo", style: { width: "100%", height: "auto", minWidth: 80 } }) })), _jsx(Grid, Object.assign({ item: true, md: 8 }, { children: _jsx(Typography, Object.assign({ variant: "body1" }, { children: palavras.slice(0, index + 1).join(" ") })) }))] })) }) })) })), _jsx(Grid, Object.assign({ item: true, xs: 12, md: 8 }, { children: _jsx(Fade, Object.assign({ in: mostrarBox, timeout: 1000 }, { children: _jsx(Card, Object.assign({ variant: "outlined" }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h6" }, { children: "Sugest\u00E3o da IA" })), _jsx(Divider, { sx: { my: 2 } }), children] }) })) })) }))] })));
};
export default IAContent;
